import { FaEye, FaTimes } from "react-icons/fa";
import { AppModal } from "../Modal/_index";
import "./_Styles/ReadOnly.css";

/*
    Shell visual unico para todas las vistas profundas de solo lectura.
    El contenido puede cambiar (manual, guia, curso, README, logbook,
    script), pero cabecera, badge, cierre, columnas y espaciado son los mismos.
*/
export const ReadOnlyModalShell = ({
    isOpen,
    onClose,
    icon,
    title,
    subtitle = "Modo lectura",
    currentLabel = null,
    navigation = null,
    children,
    meta = null,
    actions = null,
    className = "",
    ariaLabel = null,
}) => (
    <AppModal
        isOpen={isOpen}
        onClose={onClose}
        size="full"
        hasCloseButton={false}
        className={`LStudio__readonly_modal ${className}`.trim()}
    >
        <div className="LStudio__readonly_shell" role="document" aria-label={ariaLabel || `Lectura: ${title || "Registro"}`}>
            <header className="LStudio__readonly_shell_header">
                <div className="LStudio__readonly_shell_identity">
                    <span className="LStudio__readonly_shell_icon">{icon}</span>
                    <div>
                        <strong>{title || "Registro"}</strong>
                        <small>{subtitle}</small>
                    </div>
                </div>

                <div className="LStudio__readonly_shell_current">{currentLabel}</div>

                <div className="LStudio__readonly_shell_actions">
                    {actions}
                    <span className="LStudio__readonly_shell_badge"><FaEye /> Solo lectura</span>
                    <button type="button" className="LStudio__readonly_shell_close" aria-label="Cerrar modo lectura" onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>
            </header>

            <div className="LStudio__readonly_shell_body" data-has-nav={navigation ? "true" : "false"} data-has-meta={meta ? "true" : "false"}>
                {navigation && <aside className="LStudio__readonly_shell_nav">{navigation}</aside>}
                <main className="LStudio__readonly_shell_main">{children}</main>
                {meta && <aside className="LStudio__readonly_shell_meta">{meta}</aside>}
            </div>
        </div>
    </AppModal>
);
